import { render, staticRenderFns } from "./WelcomeDetail-step.vue?vue&type=template&id=2df5d93c&"
import script from "./WelcomeDetail-step.vue?vue&type=script&lang=js&"
export * from "./WelcomeDetail-step.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeDetail-step.vue?vue&type=style&index=0&scooped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VRow})
